export function transformName(value: string) {
  if (value.includes("id_")) {
    return value.replace("id_", "").toLowerCase();
  } else {
    return value.toLowerCase();
  }
}
